import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';
const wetlandsImage = require('../../images/wetlands.jpg');

const BSLAHydricSoilLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        title: 'Hydric Soils (USDA)',
        url: 'https://utility.arcgis.com/usrsvcs/servers/e10b550755d14e2997eb042c51e34628/rest/services/HYDRIC_SOILS_V2/FeatureServer/0',
        visible: false,
        opacity: 0.5,
        popupTemplate: {
            outFields: ['*'],
            title: 'Hydric Soils (USDA)',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');

                const content = (
                    <React.Fragment>
                        <BSLAPopupItemComponent label="Map Unit Name (MUNAME)" value={atts.MUNAME} />
                        <div className="mt-3">
                            <p className="mb-1">
                                <img src={wetlandsImage} className="img-thumbnail float-left mr-2" width="200" height="133" alt="Wetlands"/>
                                Issue: This layer shows potential wetlands indicated by the presence of hydric (wetland) soils as mapped by the US National Resource Conservation
                                Service (NRCS). Hydric soils often indicate current or historic wetland habitat, but were not mapped specifically to estimate wetland habitat. Most
                                wetlands are highly regulated by federal, state, and local agencies. Permits are required to impact regulated wetland habitat.
                            </p>
                            <p>
                                Cost: Regulations require that wetlands must be avoided as much as possible. After impacts to wetlands are justified, mitigation to offset the
                                impact such as creating new wetlands on site or purchasing mitigation credits is required at a cost ranging from $50,000-$200,000 per acre (not
                                including permitting costs) depending on habitat quality and type.
                            </p>
                        </div>
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLAHydricSoilLayer;
